import Box from "@mui/material/Box";
import {useServerTableContext} from "./ServerTableContext";
import type {ServerTableFrameProps} from "./types";
import {useFullscreenSnackbarAnchor} from "../../layout/DashboardSnackbarProvider";

/** Defines the normal and fullscreen layout boundary around a table surface. */
export const ServerTableFrame = ({children, padding = 0}: ServerTableFrameProps) => {
    const {isFullScreen} = useServerTableContext();
    // Fullscreen mode pins the toolbar (and the exit control) top-right, under the default toast spot.
    useFullscreenSnackbarAnchor(isFullScreen);

    return (
        <Box sx={theme => ({
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            p: padding,
            boxSizing: 'border-box',
            ...(isFullScreen && {
                position: 'fixed',
                inset: 0,
                width: '100dvw',
                height: '100dvh',
                p: 0,
                bgcolor: 'background.default',
                overflow: 'hidden',
                overscrollBehavior: 'contain',
                zIndex: theme.zIndex.modal
            })
        })}>
            {children}
        </Box>
    );
};
